export const theme = {
  eighties: {
    yellow: '#f1e95e',
    pink: '#fc5185',
    blue: '#2fcafa'
  },
  windows: '#118181',
  windowsDark: 'hsl(180, 65.4%, 25.6%)',
  windowsLight: 'hsl(180, 65.4%, 35.6%)',
  breakpoints: {
    mobile: '900px',
    preMobile: '1110px'
  }
};
